export const NUMBERING_CIRCLE_SIZE_PX = '40px';
export const GAP_BETWEEN_NUMBERING_AND_TITLE_PX = '16px';
export const GAP_BETWEEN_BUTTON_AND_CONTENT_PX = '20px';
